<template>
  <div class="d-flex align-start">
    <div :style="alertBadgeStyles">Tipp</div>
    <p class="pl-4">
      {{ message }}
      <ScrollTo
        v-if="selectorLabel"
        :label="selectorLabel"
        :target-id="selector"
        :call-before="actionBeforeCall"
        type="hyperlink"
        color="primary"
      ></ScrollTo>
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent, reactive, toRefs } from "vue"
import ScrollTo from "components/UI/ScrollTo.vue"

export type Tipp = {
  message: string
  label: string
  selector: string
  actionBeforeCall: () => void
}

export default defineComponent({
  name: "FormAlertTipp",
  components: {
    ScrollTo,
  },
  props: {
    alertTipp: { type: Object as () => Tipp, required: true },
  },
  computed: {
    alertBadgeStyles(): object {
      return {
        backgroundColor: `${this.$vuetify.theme.themes.light.primary} !important`,
        color: "white",
        padding: "4px 2px 4px 2px",
        borderRadius: "4px",
        writingMode: "vertical-lr",
        textOrientation: "upright",
      }
    },
  },
  setup(props) {
    const reactiveAlertTipp = reactive(props.alertTipp)
    const {
      message,
      label: selectorLabel,
      selector,
      actionBeforeCall,
    } = toRefs(reactiveAlertTipp)
    return {
      message,
      selectorLabel,
      selector,
      actionBeforeCall,
    }
  },
})
</script>
